// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useRef, useEffect, useContext, Fragment } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { url2md5 } from 'pub_config';
import etask from '/util/etask.js';
import { search_in_google } from '../search_in_google.ts';
import { Link } from '../link.tsx';
import { Popular_sitepics } from '../../unblock/popular_sitepics.js';
import { App_context } from '../../context.js';
import be from '../../be.js';
import user_agent from '/util/user_agent.js';
import { Download_link, show_download_link } from '/www/hola/pub/products/download_link.js';
import install_util from '/www/hola/pub/install_util.js';
import './search.module.less';
var stay_focused;
var Viddly_promo = () => {
  var item = _objectSpread(_objectSpread({}, install_util.hola_apps.more[4]), {}, {
    title: 'Viddly'
  });
  return /*#__PURE__*/React.createElement(Download_link, {
    item: item,
    source: "search",
    tag: "div",
    cls: "download_link search_promo"
  });
};
var Search_field = props => {
  var sys = user_agent.guess();
  useTranslation();
  var _useContext = useContext(App_context),
    is_plus = _useContext.is_plus,
    is_ultra = _useContext.is_ultra,
    has_svc = _useContext.has_svc;
  var sitepics = props.sitepics,
    filter = props.filter,
    busy = props.busy,
    set_busy = props.set_busy,
    active = props.active,
    popup = props.popup,
    on_change_filter = props.on_change_filter,
    on_clear = props.on_clear,
    focused = props.focused,
    set_focused = props.set_focused,
    placeholder = props.placeholder,
    icon_right = props.icon_right,
    close_on_activate = props.close_on_activate,
    color = props.color;
  var activate = (e, s) => {
    if (close_on_activate) on_close();
    return props.activate(e, s);
  };
  useEffect(() => {
    if (filter) on_change_filter({
      target: {
        value: filter
      }
    });
  }, []);
  // XXX dmitriiz: it should be backend logic, and not frontend
  // one method should return just list of model where viddly is in some
  // place
  var is_viddly = show_download_link('viddly', {
    source: 'search',
    has_svc,
    sys
  });
  var viddly_matched = !!filter && 'viddly'.indexOf((filter || '').toLowerCase()) > -1;
  var promotions = [{
    pos: 0,
    promo: Viddly_promo,
    show: is_viddly && (!filter || viddly_matched || sitepics.google)
  }];
  var timer = useRef();
  var on_focus = event => {
    be.perr({
      id: 'www_popular_search_focus'
    });
    if (popup) {
      stay_focused = true;
      timer.current = setTimeout(() => {
        document.body.style.position = 'fixed';
      }, 350);
      set_focused(true);
    }
  };
  var on_blur = event => {
    if (stay_focused) {
      event.preventDefault();
      event.target.focus();
      stay_focused = false;
      return;
    }
    if (popup) {
      document.body.style.position = 'relative';
      set_focused(false);
    }
  };
  var on_search = event => {
    if (!filter || busy) return;
    set_busy();
    var info = {
      filter
    };
    etask(function* () {
      if (sitepics.google) {
        // wait up to 500ms to let perr be sent
        info.debug_filter_undefined = encodeURIComponent(filter);
        this.spawn(etask.sleep(500));
        this.spawn(be.perr({
          id: 'www_popular_search_go',
          info
        }));
        yield this.wait_child('any');
        search_in_google(filter);
      } else {
        var sitepic = sitepics.matches[0];
        info.root_url = sitepic.link;
        be.perr({
          id: 'www_popular_search_go',
          info
        });
        activate(event, sitepic);
      }
    });
  };
  var on_close = () => {
    clearTimeout(timer.current);
    stay_focused = false;
    document.body.style.position = 'relative';
    input_ref.current.blur();
  };
  var on_key_down = event => {
    if (event.key == 'Enter') on_search(event);
    if (event.key == 'Escape') on_close();
  };
  var is_not_found = sitepics.google && (!is_viddly || !viddly_matched);
  var wrapper_cls = cn('search-field-wrapper', {
    popup,
    focused: focused || stay_focused,
    filtered: !!filter,
    not_found: is_not_found
  });
  var search_cls = cn('search-field', icon_right && 'icon-right', color && color);
  var search_input_cls = cn('search-input', filter && 'search-input-black');
  var sitepics_cols = {
    xs: 7,
    sm: 7,
    md: 7,
    lg: 7,
    xl: 7
  };
  var input_ref = useRef();
  var type = is_ultra ? 'ultra' : is_plus ? 'premium' : 'hola';
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var matches = is_not_found ? sitepics.matches.slice(0, 9) : sitepics.google ? [] : sitepics.matches.slice(0, 9);
  return /*#__PURE__*/React.createElement("div", {
    id: "search-field-root",
    className: wrapper_cls
  }, /*#__PURE__*/React.createElement("div", {
    className: search_cls
  }, /*#__PURE__*/React.createElement("p", {
    className: "search-field-title"
  }, "What site would you like to enter today?"), /*#__PURE__*/React.createElement("input", {
    className: search_input_cls,
    type: "text",
    "aria-label": "Search",
    ref: input_ref,
    placeholder: t(placeholder || 'Enter any website to access it'),
    value: filter,
    onChange: on_change_filter,
    onFocus: on_focus,
    onBlur: on_blur,
    onKeyDown: on_key_down
  }), popup && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Link, {
    className: "search-field-logo",
    to: "/",
    onClick: on_close
  }, /*#__PURE__*/React.createElement("img", {
    className: cn('hola-flame', 'lazyload'),
    alt: "hola_flame",
    src: url2md5('/www/hola/pub/img/hola_flame.svg')
  }), /*#__PURE__*/React.createElement("img", {
    className: cn(`hola-lettering ${type}`, 'lazyload'),
    alt: "hola_lettering",
    src: url2md5(`/www/hola/pub/img/${type}_lettering.svg`)
  })), /*#__PURE__*/React.createElement("button", {
    className: "search-field-button",
    onClick: on_search
  }), /*#__PURE__*/React.createElement("button", {
    className: "search-field-close",
    onClick: on_close
  }), /*#__PURE__*/React.createElement("div", {
    className: "search-field-popular"
  }, /*#__PURE__*/React.createElement("p", null, "Sorry, No results found."), /*#__PURE__*/React.createElement("h4", null, "Most popular in your country:"), focused && /*#__PURE__*/React.createElement(Popular_sitepics, {
    cls: "sitepics",
    cols_count: props.cols_count || sitepics_cols,
    col_gap: 16,
    sitepics: matches,
    limit: 7,
    active: active,
    activate: activate,
    img_load_delay: 700,
    filter: !sitepics.google && filter,
    promotions: promotions
  }))), !popup && filter && /*#__PURE__*/React.createElement("div", {
    className: "search-clear",
    onMouseDown: () => {
      stay_focused = true;
    },
    onClick: () => on_clear()
  })));
};
export { Search_field };